import { useState } from "react";
import { Navigate } from "react-router-dom";

const getUser = () => JSON.parse(sessionStorage.getItem('user'));

export const Private = ({ children }) => {
  const [user] = useState(getUser);
  const [blockedPagesList] = useState(['User','FgtsBalance', 'Chatgpt']);
  const [componentList] = useState(['simulationSettings']);
  
  if (user) {
    if (user.role === 'USER') {
      if (children.props !== undefined) {
        if (componentList.includes(children.props.name)) {
          return null;
        }
      }

      if (children.type !== undefined) {
        if (blockedPagesList.includes(children.type.name)) {
          return <Navigate to="/forbidden" />;
        }
      }
      return children;
    }

    if (user.role === 'ADMINISTRATOR') {
      return children;
    }
  }
  return <Navigate to="/forbidden" />;
}
